module.exports = __webpack_public_path__ + "static/media/Icons_yellow star.e9759269.svg";